import React, { useEffect, useState } from "react";
import Images from "../../../../../assets/images";
import {
  AppConnectionIcon,
  ChowdeckConnectIcon,
  ConnectStoreIcon,
  LumiIcon,
} from "../../../../../assets/svgIcons";
import styles from "./styles.module.scss";
import primaryComponents from "../../../../../components/primaryComponents";
import { useConnectStore } from "./useConnectStore";
import { pathConstants } from "../../../../../routes/pathContants";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetStoreList } from "../../../../../hooks/api/queries";
import CreateProductsMap from "./CreateProductsMap";
import EditProductsMap from "./EditProductsMap";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "../../../../../components/secondaryComponents/Modal/Modal";
import SuccessConnectionModal from "../SuccessConnectionModal";

const ConnectStore = ({ setChowdeckLumiConnections }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const {
    search,
    mapping_id,
    marketPlaceStores,
    storesMapping,
    productsMapping,
    updateProductsMapping,
    isLoadingMarketPlaceProducts,
    marketPlaceProducts,
    marketPlaceLumiProducts,
    isLoadingMappedUnmappedProducts,
    mappedUnmappedProducts,
    triggerToast,
    searchConncections,
    successModal,
    setSuccessModal,
  } = useConnectStore();
  const { data: storeList } = useGetStoreList();

  const [chowdeckStore, setChowdeckStore] = useState("");
  const [chowdeckStoreRef, setChowdeckStoreRef] = useState("");
  const [lumiStoreId, setLumiStoreId] = useState("");

  const [chowdeckLumiLinks, setChowdeckLumiLinks] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const lumiObjectID = (lumi_object_id) => {
    const lumiObject =
      marketPlaceLumiProducts?.find(
        (item) => item.lumi_object_id === lumi_object_id,
      ) ||
      mappedUnmappedProducts?.lumi?.find(
        (item) => item.lumi_object_id === lumi_object_id,
      );

    if (lumiObject?.lumi_object_type === "service") {
      return { service_id: lumi_object_id };
    } else if (lumiObject?.lumi_object_type === "variant") {
      return { variant_id: lumi_object_id };
    } else {
      return { product_id: lumi_object_id };
    }
  };

  const lumiObjectTypeWithID = (lumi_object_type, lumi_object_id) => {
    if (lumi_object_type === "service") {
      return { service_id: lumi_object_id };
    } else if (lumi_object_type === "variant") {
      return { variant_id: lumi_object_id };
    } else {
      return { product_id: lumi_object_id };
    }
  };

  useEffect(() => {
    if (setChowdeckLumiConnections) {
      setChowdeckLumiConnections(chowdeckLumiLinks);
    }
  }, [chowdeckLumiLinks, setChowdeckLumiConnections]);

  useEffect(() => {
    if (mappedUnmappedProducts) {
      const filteredMappedUnmapped = mappedUnmappedProducts?.marketplace
        ?.filter((item) => item?.mapped_to)
        ?.map((item) => ({
          marketplace_product_ref: item?.marketplace_product_ref,
          marketplace_product_name: item?.marketplace_product_name,
          lumi_product: lumiObjectTypeWithID(
            item?.mapped_to?.lumi_object_type,
            item?.mapped_to?.lumi_object_id,
          ),
        }));

      setChowdeckLumiLinks(filteredMappedUnmapped);
    }
  }, [mappedUnmappedProducts]);

  const handleSubmit = () => {
    const productIsUndefined = chowdeckLumiLinks.find(
      (item) =>
        item?.lumi_product?.product_id === undefined &&
        item?.lumi_product?.service_id === undefined &&
        item?.lumi_product?.variant_id === undefined,
    );
    if (productIsUndefined) {
      triggerToast("Please select a lumi product to link with");
      return;
    }

    if (pathname === pathConstants.APPS_CHOWDECK_CONNECTIONS_EDIT({ id })) {
      updateProductsMapping.mutate({
        store_mapping_id: mapping_id,
        product_mapping: chowdeckLumiLinks,
      });
    } else {
      productsMapping.mutate({
        store_mapping_id: mapping_id,
        product_mapping: chowdeckLumiLinks,
      });
    }
  };

  return (
    <>
      <div className={styles.container}>
        {pathname === pathConstants.APPS_CHOWDECK_SETUP ? (
          <>
            <div className={styles.headingContainer}>
              <div className={styles.textContainer}>
                <h4>Connect a Store & Manage Items</h4>
                <p>
                  Connect a chowdeck store to a Lumi Business store and manage
                  their items
                </p>
              </div>
              <div className={styles.connectIcons}>
                <img src={Images.chowdeck} height={40} width={40} alt="" />
                <ChowdeckConnectIcon />
                <LumiIcon />
              </div>
            </div>
            <hr />
          </>
        ) : pathname === pathConstants.APPS_CHOWDECK_CONNECT_STORE ? (
          <>
            <div className={styles.textContainer} style={{ marginLeft: 20 }}>
              <h5>New Connection</h5>
              <p>You can connect a store to another store</p>
            </div>
            <hr />
          </>
        ) : (
          <>
            <div className={styles.textContainer} style={{ marginLeft: 20 }}>
              <h5>Edit Connection</h5>
              <p>You can reconnect a store to another store</p>
            </div>
            <hr />
          </>
        )}
        <div className={styles.contentContainer}>
          <div className={styles.selectStoreHeading}>
            <div className={styles.badge}>
              <span>Step 1</span> of 2
            </div>
            <div className={styles.shortLine} />
            <h6>
              Select a Chowdeck store and a lumi Business store you want to
              connect
            </h6>
          </div>
          <div className={styles.storeConnectContainer}>
            {pathname ===
            pathConstants.APPS_CHOWDECK_CONNECTIONS_EDIT({ id }) ? (
              <div className={styles.selectContainer}>
                <div className={styles.selectItem}>
                  <primaryComponents.InputField
                    classNames="white"
                    isDisabled={true}
                    value={mappedUnmappedProducts?.marketplace_store_name}
                  />
                </div>
                <div>
                  <ConnectStoreIcon />
                </div>
                <div className={styles.selectItem}>
                  <primaryComponents.InputField
                    classNames="white"
                    isDisabled={true}
                    value={mappedUnmappedProducts?.lumi_store_name}
                  />
                </div>
              </div>
            ) : (
              <div className={styles.selectContainer}>
                <div className={styles.selectItem}>
                  <primaryComponents.SelectField
                    name="chowdeckStore"
                    value={"Select a chowdeck store"}
                    options={
                      marketPlaceStores?.map((store) => ({
                        label: store?.name,
                        value: store?.reference,
                      })) || []
                    }
                    nameKey="label"
                    idKey="value"
                    onChange={(value, label) => {
                      setChowdeckStoreRef(value);
                      setChowdeckStore(label);
                    }}
                    sideLabel="Chowdeck"
                    isDisabled={storesMapping.data}
                  />
                </div>
                <div>
                  <ConnectStoreIcon />
                </div>
                <div className={styles.selectItem}>
                  <primaryComponents.SelectField
                    name="lumiStore"
                    value={"Select a Lumi Business store"}
                    options={
                      storeList?.map((store) => ({
                        label: store?.name,
                        value: store?.id,
                      })) || []
                    }
                    nameKey="label"
                    idKey="value"
                    onChange={(value) => {
                      setLumiStoreId(value);
                    }}
                    sideLabel="Lumi Business"
                    isDisabled={storesMapping.data}
                  />
                </div>
              </div>
            )}

            <div className="d-flex justify-content-center">
              <primaryComponents.Button
                classNames="btn btn--success"
                onClick={() =>
                  storesMapping.mutate({
                    lumi_store_id: lumiStoreId,
                    marketplace_store_ref: chowdeckStoreRef,
                    marketplace_store_name: chowdeckStore,
                  })
                }
                isDisabled={
                  !lumiStoreId ||
                  !chowdeckStoreRef ||
                  !chowdeckStore ||
                  storesMapping.isLoading ||
                  storesMapping.data
                }
              >
                <AppConnectionIcon />{" "}
                <span className="small-text-size p-2">
                  {storesMapping.isLoading ? "Connecting..." : "Connect"}
                </span>
              </primaryComponents.Button>
            </div>
          </div>
          <div
            className={styles.selectStoreHeading}
            style={{ alignItems: "flex-start" }}
          >
            <div className={styles.badge}>
              <span>Step 2</span> of 2
            </div>
            <div className={styles.shortLine} style={{ marginTop: 10 }} />
            <div className={styles.selectedContainer}>
              {marketPlaceProducts || mappedUnmappedProducts ? (
                <div>
                  <h6>
                    Link items between your selected Lumi Business Store &
                    Chowdeck Store
                  </h6>
                  <p>
                    Linking your items from Chowdeck to Lumi Business matches
                    their product IDs so the two platforms can work together.
                  </p>
                  <p>
                    Don’t worry—your products in Lumi Business will stay safe
                    and won’t be affected during the process.
                  </p>
                </div>
              ) : (
                <h6>
                  Select stores and connect in{" "}
                  <span style={{ color: "#19ae57" }}>step 1</span>
                </h6>
              )}
            </div>
          </div>
          {marketPlaceProducts || mappedUnmappedProducts ? (
            <div>
              <div className={styles.linkItemsContainer}>
                <div className={styles.chowdeckContainer}>
                  <div className={styles.itemsHeading}>
                    <primaryComponents.Checkbox
                      name="selectAll"
                      id="selectAll"
                      isChecked={
                        marketPlaceProducts &&
                        marketPlaceProducts?.length === chowdeckLumiLinks.length
                          ? true
                          : mappedUnmappedProducts &&
                              mappedUnmappedProducts?.marketplace?.length ===
                                chowdeckLumiLinks.length
                            ? true
                            : false
                      }
                      onChange={(value) => {
                        if (chowdeckLumiLinks.length > 0 && value === false) {
                          setSelectedItems(chowdeckLumiLinks);
                          setChowdeckLumiLinks([]);
                        } else if (mappedUnmappedProducts) {
                          setChowdeckLumiLinks(
                            mappedUnmappedProducts?.marketplace?.map(
                              (item) => ({
                                marketplace_product_ref:
                                  item?.marketplace_product_ref,
                                marketplace_product_name:
                                  item?.marketplace_product_name,
                                lumi_product: lumiObjectTypeWithID(
                                  item?.mapped_to?.lumi_object_type,
                                  item?.mapped_to?.lumi_object_id,
                                ),
                              }),
                            ),
                          );
                        } else {
                          setChowdeckLumiLinks(
                            selectedItems.length > 0
                              ? selectedItems
                              : marketPlaceProducts?.map((item) => {
                                  const itemExists = chowdeckLumiLinks?.find(
                                    (prod) =>
                                      prod?.marketplace_product_ref ===
                                      item?.reference,
                                  );

                                  return {
                                    marketplace_product_ref: item?.reference,
                                    marketplace_product_name: item?.name,
                                    lumi_product: lumiObjectID(
                                      itemExists
                                        ? itemExists?.lumi_product?.product_id
                                        : undefined,
                                    ),
                                  };
                                }),
                          );
                        }
                      }}
                    />
                    <div className="d-flex align-items-center">
                      <img
                        src={Images.chowdeck}
                        height={28}
                        width={28}
                        alt=""
                      />
                      <h6 className="mt-2 ml-2">Chowdeck items</h6>
                    </div>
                    <primaryComponents.SearchField
                      value={search.get("query") || ""}
                      placeholder={"Search items"}
                      triggerOnInput={true}
                      showsearchBtn={true}
                      trigger={(value) => searchConncections(value)}
                      classNames={`${globalStyles.searchField}`}
                    />
                  </div>
                </div>
                <div className={styles.lumiBusinessConntainer}>
                  <div className={styles.itemsHeading}>
                    <div className="d-flex align-items-center">
                      <LumiIcon width={28} height={28} />
                      <h6 className="mt-2 ml-2">Lumi Business items</h6>
                    </div>
                  </div>
                </div>
              </div>
              {mappedUnmappedProducts
                ? mappedUnmappedProducts?.marketplace?.map((item, index) => (
                    <EditProductsMap
                      key={index}
                      index={index}
                      item={item}
                      mappedUnmappedProducts={mappedUnmappedProducts}
                      chowdeckLumiLinks={chowdeckLumiLinks}
                      setChowdeckLumiLinks={setChowdeckLumiLinks}
                    />
                  ))
                : marketPlaceProducts?.map((item, index) => (
                    <CreateProductsMap
                      key={index}
                      index={index}
                      item={item}
                      marketPlaceLumiProducts={marketPlaceLumiProducts}
                      chowdeckLumiLinks={chowdeckLumiLinks}
                      setChowdeckLumiLinks={setChowdeckLumiLinks}
                    />
                  ))}
            </div>
          ) : isLoadingMarketPlaceProducts ||
            isLoadingMappedUnmappedProducts ? (
            <div className="d-flex align-items-center justify-content-center">
              <FontAwesomeIcon
                icon={["fas", "spinner"]}
                style={{
                  fontSize: "20px",
                  color: "#7647ee",
                }}
                className="fa-spin"
              />
            </div>
          ) : null}
        </div>
        {(pathname === pathConstants.APPS_CHOWDECK_CONNECT_STORE ||
          pathname ===
            pathConstants.APPS_CHOWDECK_CONNECTIONS_EDIT({ id })) && (
          <div className={styles.btnContainer}>
            <primaryComponents.Button
              classNames="btn btn--outline mt-auto"
              type="submit"
              onClick={() =>
                navigate(`${pathConstants.APPS_CHOWDECK_CONNECTIONS}`)
              }
            >
              Back
            </primaryComponents.Button>
            <primaryComponents.Button
              classNames="btn btn--primary mt-auto"
              type="submit"
              isDisabled={
                chowdeckLumiLinks.length === 0 ||
                productsMapping.isLoading ||
                updateProductsMapping.isLoading
              }
              onClick={handleSubmit}
            >
              {pathname === pathConstants.APPS_CHOWDECK_CONNECTIONS_EDIT({ id })
                ? updateProductsMapping.isLoading
                  ? "Saving..."
                  : "Save"
                : productsMapping.isLoading
                  ? "Connecting..."
                  : "Connect"}
            </primaryComponents.Button>
          </div>
        )}
      </div>
      <Modal
        isActive={successModal}
        width={1000}
        closeModal={() => setSuccessModal(false)}
      >
        <SuccessConnectionModal closeModal={() => setSuccessModal(false)} />
      </Modal>
    </>
  );
};

export default ConnectStore;
